import { Checkbox, Flex, Text } from '@chakra-ui/react'

interface VerificationPhotoCheckboxIProps {
  isChecked: boolean
  isDisabled: boolean
  onRequiredChange: (required: boolean) => void
}

export const VerificationPhotoCheckbox = ({
  isChecked,
  isDisabled,
  onRequiredChange,
}: VerificationPhotoCheckboxIProps) => {
  return (
    <Flex align='center'>
      <Checkbox
        isChecked={isChecked}
        isDisabled={isDisabled}
        onChange={(e) => onRequiredChange(e.target.checked)}
        size='md'
      >
        <Text fontSize='md' fontWeight='semi-bold'>
          Require Verification Photo
        </Text>
      </Checkbox>
    </Flex>
  )
}
